/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

 import axios from 'axios';
 import ServicePath from "@/core/ServicePath";
 import {
    MainRequest
} from "@/core/request";
 
 export default class HumanResourceRequest extends MainRequest{

    static addHumanResource(data,token) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_ADD, data)
    }

    static listAllHumanResources(token) {
        return this.getSEC(ServicePath.HUMAN_RESOURCE_LIST_ALL)
    }

    static updateHumanaddHumanResource(data,token) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_UPDATE, data)
    }

    static deleteHumanaddHumanResource(data, token) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_DELETE, data)
    }

    static listHumanResourcesByType(data) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_BY_STATUS, data)
    }

    static allHumanResourceByBranchOffice(data) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_BY_BRANCH_OFFICE, data)
    }

    static allResponsibleByBranchOffice(data) {
        return this.postSEC(ServicePath.HUMAN_RESOURCE_BY_BRANCH_OFFICE_AND_TYPE, data)
    }

 }